import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5946658c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增分类")
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"50px"} }, "搜索：", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("已启用")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("已禁用")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, {
      title: "文章分类",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.addCate
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_a_input_search, {
                    value: _ctx.searches.keywords,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.keywords) = $event)),
                    "enter-button": "",
                    onSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch('keywords', $event, $event))),
                    placeholder: "输入标题搜索"
                  }, null, 8, ["value"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      rowKey: "id",
      loading: _ctx.loading,
      bordered: "",
      pagination: false,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'status')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              text
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 0,
                    color: "green"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: "red"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }))
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (record.status)
                ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                    key: 0,
                    title: "是否禁用分类?",
                    onConfirm: ($event: any) => (_ctx.changeStatus(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        danger: "",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    size: "small",
                    onClick: ($event: any) => (_ctx.changeStatus(record)),
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"])),
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.goSet(record)),
                style: {"margin":"5px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "onChange"])
  ]))
}